const Announcement = () => {
    return (
        <div className="announcement">
            <div className="bg-indigo-600 px-4 py-3 text-white">
                <p className="text-center text-sm font-medium">
                    Wanna get push?
                    <a href="#push" className="inline-block underline">Click here!</a>
                </p>
            </div>
        </div>
    )
}

export default Announcement;